export const Modal = (() => {
	// CONFIG
	let config = {
		modalSelector: ".modal",
		triggerSelector: "[data-modal-trigger]",
		closeSelector: ".js-close-modal",
		dialogSelector: ".modal__dialog",
		contentSelector: ".modal__content",
		visibleClass: "is-visible",
		urlParam: "show_popin",
	};

	// HELPERS
	const getYTVideoID = (url) => {
		try {
			const ytRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
			const match = url.match(ytRegex);
			return match ? match[1] : null;
		} catch {
			return null;
		}
	};

	const videoAsContent = (videoUrl, modal) => {
		const videoId = getYTVideoID(videoUrl);
		if (!videoId) return;

		const iframe = document.createElement("iframe");
		iframe.setAttribute("frameborder", "0");
		iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
		iframe.setAttribute("allowfullscreen", "true");
		iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playlist=${videoId}&mute=1&loop=1&playsinline=1&rel=0`;

		modal.querySelector(config.contentSelector)?.prepend(iframe);
	};

	// CORE
	const showModal = (trigger) => {
		const target = trigger.getAttribute("data-modal-trigger");
		const modal = document.querySelector(`[data-modal="${target}"]`);
		if (!modal) return;

		// Vidéo dynamique
		if (trigger.dataset.videoUrl) {
			videoAsContent(trigger.dataset.videoUrl, modal);
		}

		modal.classList.add(config.visibleClass);
		modal.setAttribute("aria-hidden", "false");

		modal.querySelector(config.dialogSelector)?.focus();
	};

	const closeModal = () => {
		let reloadAfterClose = false;

		document.querySelectorAll(config.modalSelector).forEach((modal) => {
			if (!modal.classList.contains(config.visibleClass)) return;

			if (modal.querySelector(".gform_confirmation_message")) {
				reloadAfterClose = true;
			}

			modal.classList.remove(config.visibleClass);
			modal.setAttribute("aria-hidden", "true");

			// Cleanup iframe
			const iframe = modal.querySelector("iframe");
			if (iframe) setTimeout(() => iframe.remove(), 300);
		});

		if (reloadAfterClose) {
			// GET navigation avoids Firefox “resubmit form data?” after a POST-backed page; reload() repeats POST.
			const nextUrl = window.location.pathname + window.location.search + window.location.hash;
			window.location.replace(nextUrl);
		}
	};

	// EVENTS (delegation)
	const bindEvents = () => {
		// OPEN modal (delegation)
		document.addEventListener("click", (e) => {
			const trigger = e.target.closest(config.triggerSelector);
			if (!trigger) return;

			e.preventDefault();
			showModal(trigger);
		});

		// CLOSE via bouton
		document.addEventListener("click", (e) => {
			if (!e.target.closest(config.closeSelector)) return;

			e.preventDefault();
			closeModal();
		});

		// CLOSE click outside dialog
		document.addEventListener("mousedown", (e) => {
			const dialog = e.target.closest(config.dialogSelector);
			if (dialog) return;

			if (e.target.closest(config.modalSelector)) {
				closeModal();
			}
		});

		// CLOSE escape
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape") closeModal();
		});
	};

	// INIT
	const init = (options = {}) => {
		config = { ...config, ...options };

		bindEvents();

		// Ouverture auto via URL
		const params = new URLSearchParams(window.location.search);
		if (params.get(config.urlParam)) {
			document.querySelectorAll(config.triggerSelector).forEach(showModal);
		}
	};

	// PUBLIC API
	return {
		init,
		open: (name) => showModal(document.querySelector(`${config.triggerSelector}="${name}"`)),
		close: closeModal,
	};
})();
